import React, { useState, useEffect } from 'react';
import WhatsAppButton from '../Components/WhatsAppButton';

function ProductNFX() {
  const [mainImage, setMainImage] = useState({
    src: require('../Photos/Products/Main Product - NFX.jpg'),
    alt: 'Main product view of NFX brick'
  });

  /*const [thumbnails, setThumbnails] = useState([
    { src: require('../Photos/Products/NFX - In Situ.png'), alt: 'Thumbnail 1' },
    { src: require('../Photos/Products/NFX - angle view.png'), alt: 'Thumbnail 2' },
    { src: require('../Photos/Products/NFX - texture - single.png'), alt: 'Thumbnail 3' },
    { src: require('../Photos/Products/NFX - texture - Multi.png'), alt: 'Thumbnail 4' }
  ]);*/

  const handleThumbnailClick = (clickedThumbnail) => {
    const newMainImage = { ...clickedThumbnail };
    const newThumbnails = thumbnails.map(thumb => 
      thumb.src === clickedThumbnail.src ? { ...mainImage } : thumb
    );
    
    setMainImage(newMainImage);
    setThumbnails(newThumbnails);
  };
  
  useEffect(() => {
    const tabButtons = document.querySelectorAll('.tab-button');
    const tabContents = document.querySelectorAll('.tab-content');

    const handleTabClick = (event) => {
      const targetId = event.currentTarget.dataset.target;

      tabButtons.forEach(button => {
        button.classList.remove('active');
        button.classList.add('text-neutral-400', 'hover:text-white');
      });

      event.currentTarget.classList.add('active');
      event.currentTarget.classList.remove('text-neutral-400', 'hover:text-white');
      
      tabContents.forEach(content => {
        if (content.id === targetId) {
          content.classList.remove('hidden');
        } else {
          content.classList.add('hidden');
        }
      });
    };

    tabButtons.forEach(button => {
      button.addEventListener('click', handleTabClick);
    });

    return () => {
      tabButtons.forEach(button => {
        button.removeEventListener('click', handleTabClick);
      });
    };
  }, []);

  return (
    <>
      <style>{`
        body {
            background-color: #1A1A1A;
            color: #F5F5F5;
            font-family: 'Inter', sans-serif;
        }
        .font-montserrat {
            font-family: 'Montserrat', sans-serif;
        }
        .accent-red {
            color: #E60023;
        }
        .bg-accent-red {
            background-color: #E60023;
        }
        /* Custom logo styles */
        .logo-diamond {
            width: 32px;
            height: 32px;
            transform: rotate(45deg);
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .logo-diamond span {
            transform: rotate(-45deg);
            color: #E60023;
        }
        /* Gallery styles */
        .gallery-main-image {
            height: 500px;
        }
        .gallery-thumbnail {
            cursor: pointer;
            border: 2px solid transparent;
            transition: border-color 0.3s ease;
        }
        .gallery-thumbnail:hover, .gallery-thumbnail.active {
            border-color: #E60023;
        }
        /* Tab styles */
        .tab-button {
            transition: color 0.3s ease, border-color 0.3s ease;
        }
        .tab-button.active {
            color: #E60023;
            border-bottom-color: #E60023;
        }
      `}</style>
      <main className="container mx-auto p-4 sm:p-6 lg:p-8">
        {/* Product Hero Section */}
        <section className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          {/* Image Gallery */}
          <div className="gallery">
            <div className="mb-4">
              <img id="mainImage" src={mainImage.src} alt={mainImage.alt} className="w-full gallery-main-image object-cover rounded-md" onError="this.onerror=null;this.src='https://placehold.co/800x600/101010/F5F5F5?text=Image+Not+Found';" />
            </div>
            {/* <div className="grid grid-cols-4 gap-4">
              {thumbnails.map((thumbnail, index) => (
                <img 
                  key={index}
                  src={thumbnail.src} 
                  alt={thumbnail.alt} 
                  className="gallery-thumbnail w-full h-24 object-cover rounded" 
                  onClick={() => handleThumbnailClick(thumbnail)}
                />
              ))}
            </div> */}
          </div>

          {/* Product Details */}
          <div className="flex flex-col justify-center">
            <div>
              <p className="text-sm uppercase tracking-widest text-neutral-400"></p>
              <h1 className="font-montserrat text-5xl md:text-6xl font-black mt-2">NFX - Non-Facing Extra</h1>
              <p className="mt-6 text-lg text-neutral-300 leading-relaxed">
                Clay bricks suitable for use, plastered or unplastered, for general building work below damp-proof course or under damp conditions or below ground level where durability rather than aesthetics is the criterion for selection.
              </p>
              <div className="flex items-center justify-center space-x-4 mt-8">
                <a href="mailto:sales@brickandclay.co.za">
                    <button className="inline-block bg-accent-red text-white font-bold uppercase tracking-widest py-4 px-10 rounded-sm hover:bg-red-700 transition-colors duration-300 text-lg">
                        Request a Quote
                    </button>
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Tabbed Information Section */}
        <section className="mt-16 lg:mt-24">
          <div className="border-b border-neutral-700">
            <nav id="tab-buttons" className="flex space-x-8" aria-label="Tabs">
              <button data-target="overview" className="tab-button active py-4 px-1 border-b-2 border-transparent text-lg font-medium">Overview</button>
              <button data-target="specs" className="tab-button py-4 px-1 border-b-2 border-transparent text-lg font-medium text-neutral-400 hover:text-white">Technical Specifications</button>
              <button data-target="projects" className="tab-button py-4 px-1 border-b-2 border-transparent text-lg font-medium text-neutral-400 hover:text-white">Projects</button>
            </nav>
          </div>
          <div className="mt-8">
            {/* Overview Content */}
            <div id="overview" className="tab-content">
              <div className="text-neutral-300 leading-relaxed max-w-4xl">
                <div className="flex items-start">
                  <span className="mr-2">&#8226;</span>
                  <span>High strength for heavier loads</span>
                </div>
                <div className="flex items-start">
                  <span className="mr-2">&#8226;</span>
                  <span>Lower water absorption</span>
                </div>
                <div className="flex items-start">
                  <span className="mr-2">&#8226;</span>
                  <span>Great for foundations, retaining walls & underground use</span>
                </div>
                <div className="flex items-start">
                  <span className="mr-2">&#8226;</span>
                  <span>Built for performance where strength matters most</span>
                </div>
              </div>
            </div>
            {/* Specifications Content */}
            <div id="specs" className="tab-content hidden">
              <table className="w-full max-w-3xl text-left text-neutral-300">
                <tbody className="divide-y divide-neutral-700">
                    <tr className="hover:bg-neutral-800">
                        <td className="py-4 pr-4 font-semibold">Product Type</td>
                        <td className="py-4 pl-4">Imperial Plaster Brick</td>
                    </tr>
                    <tr className="hover:bg-neutral-800">
                        <td className="py-4 pr-4 font-semibold">Product Classification</td>
                        <td className="py-4 pl-4">NFX (non-facing extra)</td>
                    </tr>
                    <tr className="hover:bg-neutral-800">
                        <td className="py-4 pr-4 font-semibold">Product Texture</td>
                        <td className="py-4 pl-4">Satin</td>
                    </tr>
                    <tr className="hover:bg-neutral-800">
                        <td className="py-4 pr-4 font-semibold">Dimensions (L x W x H)</td>
                        <td className="py-4 pl-4">± 222 x 106 x 73 mm</td>
                    </tr>
                    <tr className="hover:bg-neutral-800">
                        <td className="py-4 pr-4 font-semibold">Compressive Strength</td>
                        <td className="py-4 pl-4">14 - 28 MPa</td>
                    </tr>
                    <tr className="hover:bg-neutral-800">
                        <td className="py-4 pr-4 font-semibold">Water Absorption</td>
                        <td className="py-4 pl-4">&lt; 15%</td>
                    </tr>
                    <tr className="hover:bg-neutral-800">
                        <td className="py-4 pr-4 font-semibold">Average Weight</td>
                        <td className="py-4 pl-4">3.1kg</td>
                    </tr>
                </tbody>
              </table>
            </div>
            {/* Projects Content */}
            <div id="projects" className="tab-content hidden">
              <p className="text-neutral-300 leading-relaxed">Featured projects utilizing the NFX brick are coming soon.</p>
            </div>
          </div>
        </section>
        <WhatsAppButton />
      </main>
    </>
  );
}

export default ProductNFX;